<template>
    <b-media vertical-align="center">
        <b-row>
            <b-col sm="12" md="12" :lg="(7 - countEvaluationsShown).toString()">
                <b-row>
                    <b-col>
                        <indicator-progress :target="target" />
                    </b-col>
                    <b-col cols="12" sm="2" md="2" lg="2" xl="2">
                        <div class="text-center text-muted mt-xl-0">
                            <c-weight :weight="target.weight" :calibrated-weight="target.calibratedWeight" />
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <b-col>
                <b-row class="h-100">
                    <b-col>
                        <div class="text-center text-muted mt-3 mt-xl-0">
                            <c-achieved
                                :achieved="target.achieved"
                                :progressBarColor="target.range"
                                :multiplierAchieved="target.multiplierAchieved"
                            />
                        </div>
                    </b-col>
                    <!-- self -->
                    <b-col sm="12" :md="evaluationsMdCols" lg="2" v-if="showSelfEvaluation">
                        <div class="text-center text-muted mt-3 mt-xl-0">
                            <c-evaluation
                                :evaluationType="'selfEvaluate'"
                                :evaluationValue="getEvaluationValue('self')"
                                :evaluationColor="getEvaluationColor('self')"
                                :target="target"
                                :showEvaluation="showSelfEvaluation"
                                :isAllowedToEvaluate="canDoSelfEvaluation"
                                @updated="$emit('updated')"
                                @view-evaluation="$emit('view-evaluation', $event)"
                            />
                        </div>
                    </b-col>
                    <!-- manager -->
                    <b-col sm="12" :md="evaluationsMdCols" lg="2" v-if="showManagerEvaluation">
                        <div class="text-center text-muted mt-3 mt-xl-0">
                            <c-evaluation
                                :evaluationType="'managerEvaluate'"
                                :evaluationValue="getEvaluationValue('manager')"
                                :evaluationColor="getEvaluationColor('manager')"
                                :target="target"
                                :showEvaluation="showManagerEvaluation"
                                :isAllowedToEvaluate="canDoManagerEvaluation"
                                @updated="$emit('updated')"
                                @view-evaluation="$emit('view-evaluation', $event)"
                            />
                        </div>
                    </b-col>
                    <!-- committee -->
                    <b-col sm="12" :md="evaluationsMdCols" lg="2" v-if="showCommitteeEvaluation">
                        <div class="text-center text-muted mt-3 mt-xl-0">
                            <c-evaluation
                                :evaluationType="'committeeEvaluation'"
                                :evaluationValue="getEvaluationValue('committee')"
                                :evaluationColor="getEvaluationColor('committee')"
                                :target="target"
                                :showEvaluation="showCommitteeEvaluation"
                                :isAllowedToEvaluate="canDoCommitteeEvaluation"
                                @updated="$emit('updated')"
                                @view-evaluation="$emit('view-evaluation', $event)"
                            />
                        </div>
                    </b-col>

                    <b-col sm="2" md="2" align-self="center" class="btn-target-actions">
                        <div class="mt-3 mt-xl-0">
                            <checkin-button
                                :target="target"
                                :isAllowedToDoCheckin="canDoCheckIn"
                                @checkin="openTheModalCheckIn()"
                            />
                        </div>
                    </b-col>
                    <b-col sm="2" md="2" align-self="center" class="btn-target-actions">
                        <div class="text-center mt-3 mt-xl-0">
                            <edit-target-button
                                :target="target"
                                @reload="$emit('reload')"
                                :currentEventPermissions="currentEventPermissions"
                            />
                        </div>
                    </b-col>
                    <b-col sm="2" md="2" align-self="center" class="btn-target-actions">
                        <div class="text-center mt-3 mt-xl-0">
                            <delete-target-button
                                :target="target"
                                @reload="$emit('reload')"
                                :currentEventPermissions="currentEventPermissions"
                            />
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-media>
</template>

<script>
import {
    IndicatorProgress,
    CheckinButton,
    EditTargetButton,
    DeleteTargetButton,
} from '@/views/target/components/view/indicator-header'
import notification, { danger } from '@/lib/notification'
import { Weight as CWeight, Achieved as CAchieved, Evaluation as CEvaluation } from './components'
import { userPermissionsMixin } from '@/mixins'

notification.init()

export default {
    name: 'TargetHeader',
    props: ['target', 'currentUser', 'currentEventPermissions', 'isAllowedToEdit'],
    data() {
        return {
            committees: [],
        }
    },
    mixins: [userPermissionsMixin],
    components: {
        IndicatorProgress,
        CWeight,
        CAchieved,
        CEvaluation,
        CheckinButton,
        EditTargetButton,
        DeleteTargetButton,
    },
    created() {
        this.currentEventPermissions = this.target.permissionsStage
        const stagePermissions = this.$store.state.filters.currentEventPermissions
        stagePermissions.goals = this.target.permissionsStage
        this.$store.dispatch('setCurrentEventPermissions', stagePermissions)
    },
    computed: {
        hasAdminRole() {
            return (
                this.currentUser.role.name == 'local_administrator' ||
                this.currentUser.role.name == 'administrator' ||
                this.currentUser.role.name == 'god' ||
                this.currentUser.is_target_master
            )
        },
        permissions() {
            const userPermissions = this.$store.state.currentUser.user.permissions
            userPermissions.goals = this.target.permissionsStage
            return userPermissions
        },
        countEvaluationsShown() {
            let count = 0
            if (this.showSelfEvaluation) {
                count++
            }
            if (this.showManagerEvaluation) {
                count++
            }
            if (this.showCommitteeEvaluation) {
                count++
            }
            return count
        },
        evaluationsMdCols() {
            return this.countEvaluationsShown == 2 ? '4' : 6
        },
        showSelfEvaluation() {
            return (
                this.hasEventPermission(this.permissions, 'goals', this.target.level, 'allow_view_self_evaluation') ||
                this.canDoSelfEvaluation ||
                this.hasAdminRole
            )
        },
        showManagerEvaluation() {
            return (
                this.hasEventPermission(
                    this.permissions,
                    'goals',
                    this.target.level,
                    'allow_view_manager_evaluation'
                ) ||
                this.canDoManagerEvaluation ||
                this.hasAdminRole
            )
        },
        showCommitteeEvaluation() {
            return (
                this.hasEventPermission(
                    this.permissions,
                    'goals',
                    this.target.level,
                    'allow_view_committee_evaluation'
                ) ||
                this.canDoCommitteeEvaluation ||
                this.hasAdminRole
            )
        },
        canDoSelfEvaluation() {
            return this.isTargetOwner && this.currentEventPermissions[this.target.level].allow_self_evaluation
        },
        canDoManagerEvaluation() {
            return this.isManager && this.currentEventPermissions[this.target.level].allow_manager_evaluation
        },
        canDoCommitteeEvaluation() {
            return (
                this.isCommitteesUsers &&
                this.currentEventPermissions[this.target.level].allow_view_committee_evaluation
            )
        },
        canDoCheckIn() {
            const targetIsNotCompleted = !(this.target.status === 'completed')
            const checkInPermission =
                this.isFocalPoint == true
                    ? this.getCheckinFocalPointPermission
                    : this.currentEventPermissions[this.target.level].checkin
            return targetIsNotCompleted && checkInPermission
        },
        getCheckinFocalPointPermission() {
            return this.target.focalPointsPermission[0][`ID-${this.currentUser.id}`][this.target.level]
                .checkin_as_focal_point
        },
        isFocalPoint() {
            if (this.target.userFocalPointRelations.length != 0) {
                return this.target.userFocalPointRelations[0].id == this.currentUser.id
            }
            return false
        },
        isTargetOwner() {
            return this.currentUser.id == this.target.owner.id
        },
        isManager() {
            return this.currentUser.id === this.target.owner.manager_id
        },
        isCommitteesUsers() {
            return this.target.committeesUsers.includes(this.currentUser.id)
        },
    },
    methods: {
        openTheModalCheckIn() {
            this.$router.push({
                path: `/v2/target/targets/view/${this.target.id}/checkin`,
            })
        },
        notificationError() {
            danger()
        },
        getEvaluationValue(type) {
            let value
            switch (type) {
                case 'self':
                    value = this.target.ownerEvaluation ? this.target.ownerEvaluation.weightedEvaluation : null
                    break
                case 'manager':
                    value = this.target.managerEvaluation ? this.target.managerEvaluation.weightedEvaluation : null
                    break
                case 'committee':
                    value = this.target.committeeEvaluation ? this.target.committeeEvaluation.weightedEvaluation : null
                    break
            }
            return value
        },
        getEvaluationColor(type) {
            let color
            switch (type) {
                case 'self':
                    color = this.target.colors ? this.target.colors.ownerEvaluation : null
                    break
                case 'manager':
                    color = this.target.colors ? this.target.colors.managerEvaluation : null
                    break
                case 'committee':
                    color = this.target.colors ? this.target.colors.committeeEvaluation : null
                    break
            }
            return color
        },
    },
}
</script>

<style>
.btn-target-actions {
    max-width: 80px;
}
@media (max-width: 575px) {
    .text-small-sm-down {
        font-size: 12px !important;
        margin-bottom: 8px !important;
    }
}
</style>
